import PropTypes from 'prop-types';
import { useRef } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import AcademyBar from '../AcademyBar/AcademyBar';

// assets
import { IconMenu2 } from '@tabler/icons';

import { useRecoilValue } from 'recoil';
import { LoggedInState } from 'states/LoggedIn';

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const academyBarRef = useRef(null);
  const loggedIn = useRecoilValue(LoggedInState)
  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.main,
              '&:hover': {
                background: theme.palette.secondary.main,
                color: '#ffffff'
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>
      <Box marginRight={'16px'} />
      {
        // 학원 선택기는 운영 학원만 쓴다. 다른 학원 관리자에게는 고를 수 있는
        // 학원이 자기 하나뿐이고, 서버가 학원 경계를 강제하므로 골라도 자기
        // 데이터가 나온다.
        loggedIn.user.academy_is_admin ? <AcademyBar ref={academyBarRef} /> : <div></div>
      }
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
